import React from "react";
import "./Project.css";
import Fade from "react-reveal/Fade";
import book from "../images/book.png";
import native from "../images/native.PNG";
import tailwind from "../images/tailwind.png";
import { Link } from "react-router-dom";
const Project = () => {
  return (
    <div className="project" id="projects">
      <h2 className="font-heading pt-5 mt-5 text-center">
        <span className="about-title ">Projects</span>
      </h2>
      <div className="container my-5 py-5">
        <div className="row">
          <hr className="line" />
          <Fade left>
            <div className="col-md-4 project-img">
              <img src={book} className="img-project" alt="" />
            </div>
          </Fade>

          <Fade right>
            <div className="col-md-6 offset-md-1 font my-2 details-div">
              <h3 className="heading">Book Store</h3>
              <p className="details-p">
                Website of a book store where user can add or remove any items
                after logging in with their google accounts
              </p>
              <div className="skills">
                <span>React JS</span>
                <span>Express JS</span>
                <span>Node JS</span>
                <span>MongoDB</span>
                <span>Material UI</span>
                <span>Stripe JS</span>
                <span>Heroku</span>
                <span>Firebase</span>
              </div>
              <a
                href="https://github.com/MariamChowdhury/Book-Store"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button class="custom-btn btn-15 font my-4 me-4">
                  View Code
                </button>
              </a>
              <a
                href="https://book-shop-58860.web.app/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button class="custom-btn btn-15 font me-4">View Site</button>
              </a>
            </div>
          </Fade>
        </div>
        <hr className="line" />
        <div className="row ">
          <Fade left>
            <div className="col-md-4 project-img">
              <img src={native} className="img-project" alt="" />
            </div>
          </Fade>
          <Fade right>
            <div className="col-md-6 offset-md-1 font my-2 details-div">
              <h3 className="heading">Weather App</h3>
              <p className="details-p">
                A cross platform app to find weather of any valid city.
              </p>
              <div className="skills">
                <span>React Native</span>
              </div>
              <a
                href="https://github.com/MariamChowdhury/weather-react-native"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button class="custom-btn btn-15 font my-4 me-4">
                  View Code
                </button>
              </a>
              <a
                href="https://www.youtube.com/watch?v=lr9MTz-cjIs"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button class="custom-btn btn-15 font me-4">View Demo</button>
              </a>
            </div>
          </Fade>
        </div>
        <hr className="line" />
        <div className="row">
          <Fade left>
            <div className="col-md-4 project-img">
              <img src={tailwind} className="img-project" alt="" />
            </div>
          </Fade>
          <Fade right>
            <div className="col-md-6 offset-md-1 font my-2 details-div">
              <h3 className="heading">News Portal </h3>
              <p className="details-p">
                Website of a static news portal made with Tailwind CSS
              </p>
              <div className="skills">
                <span>React JS</span>
                <span>Tailwind CSS</span>
                <span>Stripe JS</span>
                <span>Firebase</span>
              </div>
              <a
                href="https://github.com/MariamChowdhury/news-portal"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button class="custom-btn btn-15 font my-4 me-4">
                  View Code
                </button>
              </a>
              <a
                href="https://news-b7c71.web.app/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button class="custom-btn btn-15 font me-4">View Site</button>
              </a>
            </div>
          </Fade>
        </div>
        <hr className="line" />
        <div className="text-center mt-5">
          <Link to="/moreProject">
            {" "}
            <button class="custom-btn btn-15 font ">View more projects</button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Project;
